if ('ambassadors-slider') {
    customElements.define(
      'ambassadors-slider',
      class AmbassadorsSlider extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          this.swiperEl = this.querySelector('.mySwiper');
          this.swiper = this.querySelector('.mySwiper');
          this.allVideos = this.querySelectorAll('video');
          this.documentAllVideos = document.querySelectorAll('.vid-slid__video video');
          this.allItems = this.querySelectorAll('.vid-slid__item');
          this.isVideoIntersecting = false;
          this.muted = true;
  
          this.activeClass = 'vid-slid__item--active';
  
          // document.addEventListener('DOMContentLoaded', () => {
          this.swiper = new Swiper(this.swiper, {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 0,
            loop: false,
            centeredSlides: false,
            slideToClickedSlide: true,
            snapToAlignment: 'start',
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              1280: {
                enabled: false,
              },
            },
          });
          // });
  
  
        
        }
      }
    );
  }
  